import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import OpenPaidMeetingPrice from './OpenPaidMeetingPrice';
export const PaidMeetingPrice = props => {
  const {
    currency,
    price,
    paid
  } = props;

  const currencyAndAmount = /*#__PURE__*/_jsx(FormattedCurrency, {
    value: price,
    currencyCode: currency
  });

  return /*#__PURE__*/_jsxs("div", {
    className: "m-bottom-2",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-1",
      "data-selenium": "paid-meeting-price",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'payments.priceHeader',
        options: {
          price: price === 0 ? /*#__PURE__*/_jsx(OpenPaidMeetingPrice, {
            currency: currency
          }) : currencyAndAmount
        }
      })
    }), /*#__PURE__*/_jsx(Small, {
      "data-selenium": `paid-meeting-price-subtitle-${paid ? 'paid' : 'unpaid'}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: paid ? 'payments.paidSubheader' : 'payments.unpaidSubheader'
      })
    })]
  });
};
export default PaidMeetingPrice;